import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SectionA from './Components/SectionA';
import { useNavigate } from "react-router-dom"
import Faq from './Components/Faq/Faq';
import Pricing from './Components/Membership/Pricing';
import Features from './Components/Features/Features';

function Home() {

  const navigateTo = useNavigate();

  const scrollToElement = (elementId) => {
    const targetElement = document.getElementById(elementId);

    if (targetElement) {
      const offset = 0;
      const targetPosition = targetElement.offsetTop + offset;

      window.scroll({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };
  const location = useLocation();

  useEffect(() => {
    const scrollInfo = location?.state?.scrollTo;
    if (scrollInfo) {
      setTimeout(() => {
        scrollToElement(scrollInfo.id, scrollInfo.offset);

        navigateTo(location.pathname, { replace: true, state: {} });
      }, 100);
    }
  }, [location.state]);

  return (
    <div>
      <SectionA />
      <Features />
      <Pricing />
      <Faq />
    </div>
  );
}

export default Home;
